module.exports = __webpack_public_path__ + "static/media/barnov.442662ab.jpg";